import React from 'react'
import {Link} from '../'

class BlogFeatured extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const { title, description, image, link } = this.props;

    return (
      <div className="BlogFeatured card">
        <Link href={link}>
          <div className="grid-row">
            {/*<div className="blog-image" style={{backgroundImage: `url(${image})`}}></div>*/}
            <div className="grid-row grid-column blog-content">
              <div className="blog-title">{title}</div>
              <div className="blog-description">{description}</div>
            </div>
          </div>
        </Link>
      </div>
    )
  }

}

export default BlogFeatured;



// WEBPACK FOOTER //
// ./src/components/blog/BlogFeatured.jsx